export const SET_LOADING = "setLoading";
export const SET_ERROR = "setError";
export const SET_AUTH = "setAuth";